module.exports = __webpack_public_path__ + "b8471548cdc6e8e3ff762c922a0d562b.svg";